import displayPaymentStatus from '@helpers/displayPaymentStatus';
import displayPaymentType from '@helpers/displayPaymentType';
import useAPI from '@hooks/useAPI';
import useErrorHandler from '@hooks/useErrorHandler';
import useSession from '@hooks/useSession';
import Order from '@models/Order';
import React, { useEffect, useState } from 'react';
import { Col, Hidden, Row, Visible } from 'react-grid-system';

function OrderListPage() {
  const API = useAPI();
  const errorhandler = useErrorHandler();
  const [orders, setOrders] = useState<Order[]>([]);
  const session = useSession();

  useEffect(() => {
    if (session.token === undefined && !session.syncSessionWithLS()) {
      // @ts-ignore
      window.location.href = '/login';
      return;
    }
  }, []);

  useEffect(() => {
    if (session.isLoggedIn)
      API.getOrderList()
        .then((res) => setOrders(res))
        .catch(errorhandler.handle);
  }, [session.isLoggedIn]);

  return (
    <div>
      <div className="order-list">
        <h1>訂單記錄</h1>
        <Hidden xs sm md>
          <Row className="table-head">
            <Col xs={5} lg={6}>
              <p>訂單內容</p>
            </Col>
            <Col xs={5} lg={6}>
              <p>詳細資訊</p>
            </Col>
          </Row>
        </Hidden>
        {orders.map((order) => (
          <OrderListItem order={order} key={order.id} />
        ))}
        {orders.length === 0 ? <p>您還沒有訂購過付費課程哦！</p> : <div />}
      </div>
    </div>
  );
}

function OrderListItem(props: { order: Order }) {
  const { order } = props;

  if (order.payments[0] === undefined) return <div />;
  const { payment_result } = order.payments[0];

  if (payment_result === undefined || payment_result === null) return <div />;

  const { topic, podcast } = order;
  if (topic === undefined) return <div />;
  if (podcast === undefined) return <div />;

  return (
    <Row
      className="order-list-item"
      style={{ margin: 0 }}
      onClick={() => {
        // @ts-ignore
        window.location.href = '/topic/' + topic.id;
      }}
    >
      <Col xs={5} lg={6}>
        <Row>
          <Col xs={12} md={4}>
            <img src={topic.image} alt="" />
          </Col>

          <Hidden xs sm>
            <Col xs={8}>
              <h3 className="topic-name">{topic.name}</h3>
              <p className="podcast-name">{podcast.title}</p>
            </Col>
          </Hidden>
        </Row>
      </Col>
      <Col xs={7} lg={6}>
        <Visible xs sm>
          <div className="topic-and-podcast-name">
            <h3 className="topic-name">{topic.name}</h3>
            <p className="podcast-name">{podcast.title}</p>
          </div>
        </Visible>

        <div>
          <p className="label">訂單編號</p>
          <p>{order.number}</p>
        </div>
        <div>
          <p className="label">實付金額</p>
          <p>NT${order.total}</p>
        </div>
        <div>
          <p className="label">付款時間</p>
          <p>{payment_result.PaymentDate}</p>
        </div>
        <div>
          <p className="label">付款方式</p>
          <p>{displayPaymentType(payment_result.PaymentType)}</p>
        </div>
        <div>
          <p className="label">付款狀態</p>
          <p>{displayPaymentStatus(order.payments[0].status)}</p>
        </div>
      </Col>
    </Row>
  );
}

export default OrderListPage;
